import axios from "../../lib/axiosInstance";

export function createEngineerFeedbackGivenByClient(payload) {
  return axios.post(`feedback/engineer`, payload).then((res) => res.data);
}

export function createClientFeedbackGivenByEngineer(payload) {
  return axios.post(`feedback/client`, payload).then((res) => res.data);
}

export function fetchFeedback(id) {
  return axios.get(`feedback/${id}`).then((res) => res.data);
}

export function fetchAllFeedbacksByUserId(userId) {
  return axios.get(`feedback/${userId}`).then((res) => res.data);
}

export function fetchUserMarketplaceRating(userId) {
  return axios
    .get(`feedback/marketplaceRating?userId=${userId}`)
    .then((res) => res.data);
}
